// extracted by mini-css-extract-plugin
export default {"wrapper":"jN-z","firstToReview":"kN-z","productCards":"lN-z","productCard":"mN-z","stars":"nN-z","hidden":"oN-z"};